import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import MyPlugin from './plugin'
import Show from '@/components/loading/index.js'
import ShowLogin from '@/components/check_login/index.js'
import '@/utils/antd/components_use'
import '@/utils/weihai/components_use' // 微海统一登录组件
import '@/utils/elementui/components_use' // 为了支持统一登录组件，引入elementui
import '@/utils/vxeTable'
import '@/router/router-guards'
import './assets/css/index.less'
import { prefetchApps } from 'qiankun'
import { config } from './microAppsConfig'
import * as MITO from '@mitojs/web'

Vue.config.productionTip = false

Vue.use(MyPlugin)
Vue.use(Show)
Vue.use(ShowLogin)

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')

const prefetchConfig = config.filter(item => item.prefetch)
prefetchApps(prefetchConfig)

// 清空缓存数据避免切换用户的时候没有清楚缓存数据
localStorage.setItem('qiaocai_pc_BuriedKey', '')
localStorage.setItem('qiaocai_pc_companyName', '')
// 埋点初始化
MITO.init({
  apikey: process.env.VUE_APP_ID,
  dsn: process.env.VUE_APP_DNS + '/lo/re',
  debug: true,
  beforeDataReport (data) {
    if (data && data.data && data.data.message && /^\{.+\}$/.test(data.data.message)) {
      const message = JSON.parse(data.data.message)
      if (message.appCode) return message
    }
  },
  silentXhr: true,
  silentFetch: true,
  silentConsole: true,
  maxDuplicateCount: 9999
})
